module.exports = __webpack_public_path__ + "static/img/9.9233d23.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/14/zh/9.png
// module id = /YSP
// module chunks = 0